import { id } from "../../../../date-fns/locale/id.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    id
  }
};